/**
 * Attendance's place in the navigation. Under ui_uplift = next it belongs to Calendar & Events
 * (docs/design/MODULE_MAPS.md); the classic layout keeps it in Ministry until the flag ships.
 */
export const ATTENDANCE_PATH = "/attendance";

/**
 * Moves the /attendance route prefix from the Ministry sidebar entry to Calendar's, so the
 * sidebar highlights Calendar on the Attendance page. Items without it are returned as they are.
 */
export function placeAttendanceUnderCalendar<T extends { href?: string; matchPrefixes?: string[] }>(items: T[]): T[] {
  return items.map((item) => {
    if (item.href === "/ministry" && item.matchPrefixes?.includes(ATTENDANCE_PATH)) {
      return { ...item, matchPrefixes: item.matchPrefixes.filter((prefix) => prefix !== ATTENDANCE_PATH) };
    }
    if (item.href === "/events" && item.matchPrefixes && !item.matchPrefixes.includes(ATTENDANCE_PATH)) {
      return { ...item, matchPrefixes: [...item.matchPrefixes, ATTENDANCE_PATH] };
    }
    return item;
  });
}
